"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhysicalStatus = void 0;
var PhysicalStatus;
(function (PhysicalStatus) {
    PhysicalStatus["ZERO"] = "000";
    PhysicalStatus["IN_OPERATION"] = "IBD";
    PhysicalStatus["OUT_OF_OPERATION"] = "UBD";
    PhysicalStatus["DEMOLISHED"] = "SLP";
    PhysicalStatus["UNDER_CONSTRUCTION"] = "IAL";
})(PhysicalStatus = exports.PhysicalStatus || (exports.PhysicalStatus = {}));
exports.default = PhysicalStatus;
